export const CODE_TEMPLATES_INDENT = 6;
